module.exports = __webpack_public_path__ + "static/media/check.6ac4dc90.svg";